import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent implements OnInit {
  constructor(public authService: AuthService, public router: Router, private spinnerService: SpinnerService) {}

  ngOnInit(): void {
    this.spinnerService.showSpinner();
    setTimeout(() => this.spinnerService.hideSpinner(), 2000);
    if (!this.authService.getUser().isAdmin) this.authService.logout();
  }
}
